import { Controller } from 'stimulus';

// Mirrors a design's resolved screenshot URL onto `data-board-image` once the
// `designs--lazy-loading` controller (bound elsewhere, possibly on a different element
// rendering the same design) reports success, so callers can read a plain, up-to-date
// image URL without inspecting any lazy-loading markup themselves.
export default class extends Controller {
  update(event) {
    const { detail } = event;
    const { data } = detail;
    const { variants } = data;

    const imageUrl = variants['512x384'];

    if (imageUrl) {
      this.element.dataset.boardImage = imageUrl;
    }
  }
}
